import * as React from 'react';
import { SkeletonLoader } from '@repo/design-system-kit';
import cx from 'clsx';
import { Carousel, CarouselItem } from '#components/carousel';
import loaderStyles from './price-plans-container.skeleton.module.css';
import styles from './price-plans-container.module.css';

function CardSkeleton(): React.JSX.Element {
  const features = [1, 2, 3, 4, 5, 6];

  return (
    <div className={loaderStyles.cardContainer} data-test-price-plan-card-loader>
      <SkeletonLoader.Line width="40%" />
      <div className={loaderStyles.block}>
        <SkeletonLoader.Line height="8px" width="100%" />
        <SkeletonLoader.Line height="8px" width="50%" />
      </div>
      <div className={loaderStyles.priceBox}>
        <div className={cx(loaderStyles.block, loaderStyles.price)}>
          <SkeletonLoader.Line height="12px" standalone width="25%" />
          <SkeletonLoader.Line height="12px" standalone width="25%" />
          <SkeletonLoader.Line standalone width="50%" />
        </div>
        <SkeletonLoader.Line height="8px" width="80%" />
      </div>
      <div className={cx(loaderStyles.block, loaderStyles.ctaBox)}>
        <SkeletonLoader.Block height="40px" width="100%" />
        <SkeletonLoader.Line height="8px" width="50%" />
      </div>
      {features.map(feature => (
        <div className={loaderStyles.block} key={feature}>
          <SkeletonLoader.Line height="8px" standalone width="100%" />
          <SkeletonLoader.Line height="8px" width="70%" />
        </div>
      ))}
    </div>
  );
}

export function PricePlanContainerSkeleton(
  props: React.HTMLAttributes<HTMLDivElement>
): React.JSX.Element {
  return (
    <div className={styles.negativeMargin} {...props}>
      <div className={styles.mobileView}>
        <div data-test-mobile-price-plan-loader>
          <Carousel options={{ align: 'start' }} slideSize="85%">
            {[1, 2, 3].map(card => (
              <CarouselItem className={styles.pricePlanWrapper} key={card}>
                <CardSkeleton />
              </CarouselItem>
            ))}
          </Carousel>
        </div>
      </div>
      <div className={styles.desktopView}>
        <div className={styles.container} data-test-desktop-price-plan-loader>
          <div className={cx(styles.pricePlanWrapper, styles.column)}>
            <CardSkeleton />
          </div>
          <div className={cx(styles.pricePlanWrapper, styles.column)}>
            <CardSkeleton />
          </div>
          <div className={cx(styles.pricePlanWrapper, styles.column)}>
            <CardSkeleton />
          </div>
        </div>
      </div>
    </div>
  );
}
